import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { getStaticFileUrl } from "../utils/config";

interface OrganizationData {
  title: string;
  description: string;
  imageUrl: string;
}

export const Organization = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [organizationData, setOrganizationData] = useState<OrganizationData>({
    title: 'MEDIA & CONTENTS & PERFORMANCE',
    description: '영상, SNS콘텐츠, 애니메이션, 오프라인 행사 등 각 분야의 전문가들이\n사내에 있어,\n클라이언트 프로젝트가 유기적으로 진행됩니다.',
    imageUrl: '/img/about/organization.png',
  });

  useEffect(() => {
    // 서버에서 About 데이터 불러오기
    const loadAboutData = async () => {
      try {
        const { aboutApi } = await import('../services/api');
        const data = await aboutApi.getAboutData();
        if (data.organization) {
          setOrganizationData(data.organization);
        }
      } catch (error) {
        console.error('About 데이터 로드 실패:', error);
      }
    };
    loadAboutData();
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#f5f5f5", // 배경색 변경
      }}
    >
      <Typography
        sx={{
          fontSize: isMobile ? "2rem" : "2.75rem", // 32px : 44px
          fontWeight: "700",
          marginBottom: "10px",
          color: "#E23C3C", // 강조 색상
        }}
      >
        {organizationData.title}
      </Typography>
      <Typography
        style={{
          fontSize: isMobile ? "1rem" : "1.25rem", // 16px : 20px
          paddingBottom: "4rem",
          textAlign: "center",
        }}
      >
        {organizationData.description.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < organizationData.description.split('\n').length - 1 && <br />}
          </React.Fragment>
        ))}
      </Typography>

      {/* 조직도 이미지 */}
      <Box
        component="img"
        src={getStaticFileUrl(organizationData.imageUrl)}
        alt="조직도"
        sx={{
          display: "block",
          margin: "0 auto 60px",
          maxWidth: "750px",
          width: "100%",
          height: "auto",
        }}
      />
    </Box>
  );
};

export default Organization;
